import type { SVGProps } from "react";

/**
 * bfl
 * @category Social Media & Brands
 */
export default function IconBfl(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 32 32' fill='none' aria-hidden {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M21.667 14.034h-2.83l-2.83-4.008-8.825 12.491h2.835l5.99-8.483h2.83l-5.99 8.482h2.843zM16.01 6l7.635 10.809h-4.467v-2.318l-3.167-4.482-3.15 4.474v2.326H2.7L16.01 6z'
        clipRule='evenodd'
      />
    </svg>
  );
}
